"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.V2_ClerkErrorBoundary = void 0;
const tslib_1 = require("tslib");
const react_1 = require("@remix-run/react");
const react_2 = tslib_1.__importDefault(require("react"));
const Interstitial_1 = require("./Interstitial");
/**
 * Support for Remix ErrorBoundary v2.
 * You need to have the v2_errorBoundary flag enabled in your Remix config,
 * as shown here: https://remix.run/docs/en/main/route/error-boundary-v2
 *
 * @experimental This API is experimental and might change. This API will become stable
 * once Remix officially releases v2.
 */
function V2_ClerkErrorBoundary(RootErrorBoundary) {
    return () => {
        var _a, _b;
        const error = (0, react_1.useRouteError)();
        if ((0, react_1.isRouteErrorResponse)(error)) {
            const { __clerk_ssr_interstitial_html } = ((_b = (_a = error === null || error === void 0 ? void 0 : error.data) === null || _a === void 0 ? void 0 : _a.clerkState) === null || _b === void 0 ? void 0 : _b.__internal_clerk_state) || {};
            if (__clerk_ssr_interstitial_html) {
                return react_2.default.createElement(Interstitial_1.Interstitial, { html: __clerk_ssr_interstitial_html });
            }
        }
        if (!RootErrorBoundary) {
            return undefined;
        }
        return react_2.default.createElement(RootErrorBoundary, null);
    };
}
exports.V2_ClerkErrorBoundary = V2_ClerkErrorBoundary;
